import React from 'react';
import {
  Typography,
  Box,
  FormHelperText,
  Autocomplete,
  TextField
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { generateGuid } from 'helpers';
import { Controller } from 'react-hook-form';
import { TooltipCustom } from 'components/common';


export default function FormInputAutocomplete(props) {
  const {
    name='combo-box',
    control,
    label,
    variant='outlined',
    size='small',
    disabled=false,
    options=[],
    position='vertical',
    sx,
    helperText,
    className,
    onChange
  } = props;
  const [t, i18n] = useTranslation();
  const defaultId = !props?.id && `select-${generateGuid()}`;
  const onChangeCustom = onChange;

  const optionsMap = options.reduce((a, v) => ({ ...a, [v.value]: v}), {});

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.5,
        flexDirection: position === 'vertical' ? 'column' : 'row',
        alignItems: position === 'vertical' ? 'flex-start' : 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 1,
          alignItems: 'center',
        }}
      >
        <Typography variant="body1" id={`label-title-${defaultId}`}>
          {i18n.exists(label) ? t(label) : label}
        </Typography>
        {helperText && <TooltipCustom title={helperText} />}
      </Box>

      <Controller
        control={control}
        name={name}
        id={defaultId}
        render={({ field: { ref, value, onChange, ...field }, fieldState: { error }, ...lessField }) => (
          <>
            <Autocomplete
              disablePortal
              variant={variant}
              disabled={!!disabled}
              autoComplete={true}
              value={optionsMap[value]}
              size={size}
              sx={sx}
              className={className}
              noOptionsText={t('common.components.noOptionsText')}
              options={options}
              onChange={(event, item) => {
                onChange(item?.value);
                if (onChangeCustom) {
                  onChangeCustom(item?.value);
                }
              }}
              isOptionEqualToValue={(option, value) => option.value.toString() === value.value.toString()}
              renderInput={(params) =>
                <TextField
                  {...params}
                  {...field}
                  fullWidth
                  inputRef={ref}
                 />
              }
            />
            {!!error ? (
              <FormHelperText error>{error?.message}</FormHelperText>
            ) : null}
          </>
        )}
      />
    </Box>
  );
}
